// --- utils/mockData.js ---

import { FaShoppingCart, FaDollarSign, FaChartLine, FaUsers } from "react-icons/fa";

// export const dashboardData = {
//   metrics: [
//     {
//       title: "Total Orders",
//       value: 1234,
//       change: "+12%",
//       positive: true,
//     },
//     {
//       title: "Revenue",
//       value: "$56,789",
//       change: "-5%",
//       positive: false,
//     },
//     {
//       title: "Average Order Value",
//       value: "$45.98",
//       change: "+8%",
//       positive: true,
//     },
//     {
//       title: "Customer Count",
//       value: 345,
//       change: "+3%",
//       positive: true,
//     },
//   ],
//   revenueTrends: [
//     {
//       name: "Mon",
//       value: 1200,
//       details: [
//         { id: 1, orderId: "ORD-701", amount: "$150", date: "2025-07-14" },
//         { id: 2, orderId: "ORD-702", amount: "$200", date: "2025-07-14" }
//       ]
//     },
//     {
//       name: "Tue",
//       value: 1500,
//       details: [
//         { id: 3, orderId: "ORD-703", amount: "$300", date: "2025-07-15" }
//       ]
//     },
//     {
//       name: "Wed",
//       value: 1000,
//       details: [
//         { id: 4, orderId: "ORD-704", amount: "$400", date: "2025-07-16" }
//       ]
//     },
//     {
//       name: "Thu",
//       value: 1400,
//       details: [
//         { id: 5, orderId: "ORD-705", amount: "$500", date: "2025-07-17" }
//       ]
//     },
//     {
//       name: "Fri",
//       value: 900,
//       details: [
//         { id: 6, orderId: "ORD-706", amount: "$250", date: "2025-07-18" }
//       ]
//     },
//     {
//       name: "Sat",
//       value: 1800,
//       details: [
//         { id: 7, orderId: "ORD-707", amount: "$600", date: "2025-07-19" }
//       ]
//     },
//     {
//       name: "Sun",
//       value: 1600,
//       details: [
//         { id: 8, orderId: "ORD-708", amount: "$450", date: "2025-07-20" }
//       ]
//     }
//   ]
// ,
//   services: [
//     {
//       name: "Laundry",
//       value: 40,
//       details: [
//         { id: 1, customer: "Alice", amount: "$12", date: "2025-07-01" },
//         { id: 2, customer: "Bob", amount: "$18", date: "2025-07-02" },
//       ],
//     },
//     {
//       name: "Tailoring",
//       value: 30,
//       details: [
//         { id: 3, customer: "Sam", amount: "$20", date: "2025-07-03" },
//       ],
//     },
//     {
//       name: "Dry Cleaning",
//       value: 20,
//       details: [
//         { id: 4, customer: "Jane", amount: "$25", date: "2025-07-04" },
//       ],
//     },
//     {
//       name: "Ironing",
//       value: 10,
//       details: [
//         { id: 5, customer: "Mark", amount: "$10", date: "2025-07-05" },
//       ],
//     },
//   ],
// };

export const dashboardData = {
  metrics: [
    {
      title: "Total Orders",
      value: 0,
      change: "0%",
      positive: true,
      icon:FaShoppingCart
    },
    {
      title: "Revenue",
      value: "0%",
      change: "0%",
      positive: true,
      icon:FaDollarSign

    },
    {
      title: "Average Order Value",
      value: "0",
      change: "0%",
      positive: true,
      icon:FaChartLine

    },
    {
      title: "Customer Count",
      value: 0,
      change: "0%",
      positive: true,
      icon:FaUsers

    },
  ],
  revenueTrends: [
  ]
,
  services: [
    {
      name: "Laundry",
      value: 0
    },
    {
      name: "Tailoring",
      value: 0
    },
    {
      name: "Dry Cleaning",
      value: 0
    },
    {
      name: "Ironing",
      value: 0
    },
  ],
};


const week = ["Week 1", "Week 2", "Week 3", "Week 4"]

export const campaignData = {
  metrics: [
    {
      title: "Total Redemptions",
      value: 5000,
      change: "+12%",
      positive: true,
    },
    {
      title: "Total Revenue",
      value: "$50,000",
      change: "-5%",
      positive: false,
    },
    {
      title: "Total Users ",
      value: "990",
      change: "+8%",
      positive: true,
    },
  ],
   revenueTrends : week.map((weekLabel, index) => ({
  name: weekLabel,
  value: [12000, 15000, 10000, 14000][index],
  details: [
    {
      id: 1,
      orderId: `ORD-W${index + 1}01`,
      amount: "$500",
      date: `2025-07-${3 + index * 7}`,
    },
    {
      id: 2,
      orderId: `ORD-W${index + 1}02`,
      amount: "$850",
      date: `2025-07-${5 + index * 7}`,
    },
    {
      id: 3,
      orderId: `ORD-W${index + 1}03`,
      amount: "$1200",
      date: `2025-07-${7 + index * 7}`,
    },
  ],
})),
  services: [
    {
      name: "Summer Sale",
      value: 40,
      details: [
        { id: 1, customer: "Alice", amount: "$12", date: "2025-07-01" },
        { id: 2, customer: "Bob", amount: "$18", date: "2025-07-02" },
      ],
    },
    {
      name: "Back to School",
      value: 30,
      details: [
        { id: 3, customer: "Sam", amount: "$20", date: "2025-07-03" },
      ],
    },
    {
      name: "Holiday Special",
      value: 20,
      details: [
        { id: 4, customer: "Jane", amount: "$25", date: "2025-07-04" },
      ],
    },
    {
      name: "Spring Savings",
      value: 10,
      details: [
        { id: 5, customer: "Mark", amount: "$10", date: "2025-07-05" },
      ],
    },
      {
      name: "Flash Sale",
      value: 30,
      details: [
        { id: 5, customer: "Mark", amount: "$10", date: "2025-07-05" },
      ],
    },
  ],
};